import * as angular from 'angular';
import { DirectiveDefinition } from './directiveDefinition';

class CompiledController implements angular.IController {
    static $inject = ['$scope', '$compile', '$element'];

    constructor(
        private _$scope: angular.IScope,
        private _$compile: angular.ICompileService,
        private _$element: angular.IAugmentedJQuery
    ) {
    }

    $onInit() {
        const template = this._$scope['template'];
        const newElement = angular.element(template);
        this._$element.append(newElement);
        this._$compile(newElement)(this._$scope);
    }
}

export const wtCompiledDirective: DirectiveDefinition = {
    directiveId: 'wtCompiled',
    restrict: 'E',
    controller: CompiledController,
    scope: {
        template: '=',
        item: '=',
        formController: '=',
        save: '&?',
        cancel: '&?',
        dashboards: '=?',
        groups: '=?',
        isBindable: '<?',
        viewModels: '<?'
    }
};